import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import FollowUpQuestions from '../HiringManager/FollowUpQuestions';
import JobDescriptions from '../HiringManager/JobDescriptions';
import InterviewQuestions from '../JobManagement/InterviewQuestions';
import AssessmentHeader from './AssessmentHeader';
import '../css/HomePage.css';
import { Tabs } from "flowbite-react";
import { Breadcrumb } from "flowbite-react";

function CompletedSection() {
  const location = useLocation();
  const {
    roleName: initialRoleName,
    briefDescription: initialBriefDescription,
    jobDescription: initialJobDescription,
    followUpQuestions: initialFollowUpQuestions,
    interviewQuestions: initialInterviewQuestions,
    companyName: initialCompanyName,
    uid: uid
  } = location.state;

  const [roleName, setRoleName] = useState(initialRoleName);
  const [briefDescription, setBriefDescription] = useState(initialBriefDescription);
  const [jobDescription, setJobDescription] = useState(initialJobDescription);
  const [followUpQuestions, setFollowUpQuestions] = useState(initialFollowUpQuestions);
  const [interviewQuestions, setInterviewQuestions] = useState(initialInterviewQuestions);
  const [companyName, setCompanyName] = useState(initialCompanyName || '');
  const [displaySection, setDisplaySection] = useState('jobDescription');
  const [isEditingBriefDescription, setIsEditingBriefDescription] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const handleEditBriefDescription = () => {
    setIsEditingBriefDescription(true);
  };

  const handleSaveBriefDescription = () => {
    setIsEditingBriefDescription(false);
    handleGenerate(roleName, briefDescription);
  };

  const handleUpdate = (questionIndex, answer) => {
    const endpoint = '/update-job-description';
    const url = apiUrl + endpoint; // Correct URL
    setIsUpdating(true);
    console.log(isUpdating);
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        job_description: jobDescription,
        answers: [{ index: questionIndex, answer }]
      }),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Updated data:', data); // Log response data
        setJobDescription(data.updated_job_description);
        setInterviewQuestions(data.updated_interview_questions || []); // Ensure it's an array
      })
      .catch(error => {
        console.error('Error updating job description:', error);
      })
      .finally(() => {
        setIsUpdating(false); // Set isGenerating to false
      });
  };

  const updatedJobDescription = (newDescription) => {
    setJobDescription(newDescription);
  };

  const updateInterviewQuestions = (newQuestions) => {
    setInterviewQuestions(newQuestions);
  };

  const handleGenerate = (roleName, description) => {
    const endpoint = '/generate-job-description';
    const url = apiUrl + endpoint; // Correct URL
    console.log("generate job description");
    setRoleName(roleName);
    setBriefDescription(description);
    setIsGenerating(true); // Set isGenerating to true
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ role_name: roleName, description: description }),
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        setJobDescription(data.job_description);
        setFollowUpQuestions(data.follow_up_questions || []);
        setInterviewQuestions(data.interview_questions || []);
        setIsCompleted(true);
      })
      .catch(error => {
        console.error('Error fetching job description:', error);
      })
      .finally(() => {
        setIsGenerating(false);
      });
  };

  return (
    <div className='followup-questions-container'>
      <div className='followup-questions'>
        <div className='followup-questions-header'>
          <h2 className='home-rolename-text'>{roleName}</h2>
          <button onClick={isEditingBriefDescription ? handleSaveBriefDescription : handleEditBriefDescription} className='edit-generate-button'>
            {isEditingBriefDescription ? 'Save' : 'Edit'}
          </button>
        </div>
        {isEditingBriefDescription ? (
          <div>
            <textarea
              value={briefDescription}
              onChange={(e) => setBriefDescription(e.target.value)}
              className='brief-description-input'
            />
          </div>
        ) : (
          <p className='brief-description'>{briefDescription}</p>
        )}
        <FollowUpQuestions
          followUpQuestions={followUpQuestions}
          onUpdate={handleUpdate}
          roleName={roleName}
          isUpdating={isUpdating}
        />
      </div>
      <div className='job-descriptions'>
        {/* <button className='description-button' onClick={() => setDisplaySection('jobDescription')}>Job Description</button>
        <button className='interview-button' onClick={() => setDisplaySection('interviewQuestions')}>Interview Questions</button>
        {displaySection === 'jobDescription' ? (
          <JobDescriptions jobDescription={jobDescription} updatedJobDescription={updatedJobDescription} />
        ) : (
          <InterviewQuestions interviewQuestions={interviewQuestions} updateInterviewQuestions={updateInterviewQuestions} />
        )} */}
        <Tabs aria-label="Tabs with underline" variant="underline">
          <Tabs.Item active title="Job Description" >
            <JobDescriptions jobDescription={jobDescription} updatedJobDescription={updatedJobDescription} />
          </Tabs.Item>
          <Tabs.Item title="Interview Questions" >
            <InterviewQuestions interviewQuestions={interviewQuestions} updateInterviewQuestions={updateInterviewQuestions} roleName={roleName} companyName={companyName} />
          </Tabs.Item>
        </Tabs>
      </div>
    </div>


  );
}

export default CompletedSection;